module.exports = __webpack_public_path__ + "static/media/upload_select.d49e774a.svg";